import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StatusMaster } from '../models/status.master';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  constructor(private httpClient: HttpClient
  ) { }

  GetStatusMasterData(): Observable<any> {
    const url = `${environment.gateway_url}/status`
    return this.httpClient.get<StatusMaster>(url).pipe(
      map(item => {
        return item;
      })
    );
  }
  
}
